import { Pipe, PipeTransform } from '@angular/core';
import moment from 'moment-timezone';

@Pipe({
  name: 'dateDayPlusOne',
})
export class DateDayPlusOnePipe implements PipeTransform {
  public transform(value: string, format: string = ''): string {
    return moment(value).add(1, 'days').format(format);
  }
}
